export default "__VITE_ASSET__C0I4J0ze__"